/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FilterSearchBox } from "@octopusdeploy/design-system-octopus-components";
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import { CommunityActionTemplateList } from "~/components/ActionTemplates/CommunityActionTemplateList";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import { PageContent } from "~/components/PageContent/PageContent";
import { timeOperationOptions } from "~/utils/OperationTimer/timeOperation";
import styles from "./style.module.less";
interface CommunityStepTemplatesPageProps {
    spaceId: string;
}
interface CommunityStepTemplatesPageState extends DataBaseComponentState {
    templates: ActionTemplateSearchResource[];
    isLoaded: boolean;
    filterText?: string;
    projectIdToComeBackTo?: string;
}
export class CommunityStepTemplatesPage extends DataBaseComponent<CommunityStepTemplatesPageProps, CommunityStepTemplatesPageState> {
    constructor(props: CommunityStepTemplatesPageProps) {
        super(props);
        this.state = {
            templates: null!,
            isLoaded: false,
            filterText: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const templates = await repository.ActionTemplatesV2.search();
            this.setState({
                templates: templates.filter((t) => !t.IsInstalled),
                isLoaded: true,
            });
        }, { timeOperationOptions: timeOperationOptions.forInitialLoad() });
    }
    render() {
        return (<PageContent header={{
                title: "Choose Step Template",
                breadcrumbs: [{ label: "Step Templates", pageUrl: links.stepTemplatesPage.generateUrl({ spaceId: this.props.spaceId }) }],
            }} filters={{
                inputs: [
                    <FilterSearchBox placeholder="Filter by name, category or description..." onChange={(value) => this.setState({ filterText: value.toLowerCase() })} fullWidth={true} autoFocus={true} containerClassName={styles.filterSearchBoxContainer}/>,
                ],
            }} busy={this.state.busy} errors={this.errors}>
                {this.state.isLoaded && (<CommunityActionTemplateList spaceId={this.props.spaceId} templates={this.state.templates} installationActionName="Install" onPostSelectionUrlRequested={(template) => links.stepTemplatesPage.generateUrl({ spaceId: this.props.spaceId })} onDetailsUrlRequested={(template) => ({ href: links.communityStepTemplatePage.generateUrl({ spaceId: this.props.spaceId, templateId: template.CommunityActionTemplateId! }), external: false })} filter={this.state.filterText}/>)}
            </PageContent>);
    }
    static displayName = "CommunityStepTemplatesPage";
}
